import {
  AccountBalanceWalletOutlined,
  AccountTreeOutlined,
  AltRouteOutlined,
  AssignmentIndOutlined,
  BusinessOutlined,
  DashboardOutlined,
  DescriptionOutlined,
  EventAvailableOutlined,
  FactCheckOutlined,
  GroupsOutlined,
  InboxOutlined,
  IntegrationInstructionsOutlined,
  ManageAccountsOutlined,
  PaletteOutlined,
  PersonOutlined,
  PersonSearchOutlined,
  RedeemOutlined,
  RuleOutlined,
  SecurityOutlined,
  SwapHorizOutlined,
  TimelineOutlined,
  TuneOutlined,
  UploadFileOutlined,
  VerifiedOutlined,
  WorkOutlineOutlined,
} from '@mui/icons-material';
import type { ReactNode } from 'react';
import type { HeydayPage } from './heydayPageManifest';

/** 메뉴와 일반 페이지 제목이 같은 페이지 아이콘을 사용합니다. */
export const heydayPageIcons: Readonly<Record<HeydayPage, ReactNode>> = {
  'my-home': <DashboardOutlined />,
  'my-tasks': <FactCheckOutlined />,
  'my-workflows': <AltRouteOutlined />,
  'my-workflow-requests': <InboxOutlined />,
  'my-profile': <PersonOutlined />,
  'my-absence': <EventAvailableOutlined />,
  'my-documents': <VerifiedOutlined />,
  'directory': <AccountTreeOutlined />,
  'home': <DashboardOutlined />,
  'people': <GroupsOutlined />,
  'organization': <AccountTreeOutlined />,
  'staffing': <SwapHorizOutlined />,
  'lifecycle': <RuleOutlined />,
  'inbox': <InboxOutlined />,
  'absence': <EventAvailableOutlined />,
  'absence-settings': <RedeemOutlined />,
  'rewards': <AccountBalanceWalletOutlined />,
  'headcount': <WorkOutlineOutlined />,
  'workflow': <AltRouteOutlined />,
  'workflow-templates': <FactCheckOutlined />,
  'workflow-approval-settings': <RuleOutlined />,
  'workflow-requests': <InboxOutlined />,
  'bulk': <UploadFileOutlined />,
  'documents': <DescriptionOutlined />,
  'certificates': <VerifiedOutlined />,
  'recruiting-home': <DashboardOutlined />,
  'requisitions': <AssignmentIndOutlined />,
  'candidates': <PersonSearchOutlined />,
  'pipeline': <TimelineOutlined />,
  'interviews': <FactCheckOutlined />,
  'offers': <WorkOutlineOutlined />,
  'recruiting-reports': <TimelineOutlined />,
  'admin-company-info': <BusinessOutlined />,
  'admin-getting-started': <FactCheckOutlined />,
  'admin-affiliates': <AccountTreeOutlined />,
  'admin-company-seals': <VerifiedOutlined />,
  'admin-reference-data': <TuneOutlined />,
  'admin-appearance': <PaletteOutlined />,
  'admin-features': <TuneOutlined />,
  'admin-security': <SecurityOutlined />,
  'admin-integrations': <IntegrationInstructionsOutlined />,
  'admin-certificates': <VerifiedOutlined />,
  'admin-audit': <ManageAccountsOutlined />,
};
